// Depricated
// import { Plugins } from "@capacitor/core";
// const { Device } = Plugins
import { config } from "../../config";
import axios from "axios";
import moment from "moment";

import { Profile, Gender, NewProfile } from '../../entity/authentication/profile';
import { Credential, NewCredential } from '../../entity/authentication/credential';
import { User } from '../../entity/authentication/user';
import { SecretQuestion } from '@/entity/authentication/secret-questions';
import { LocalStorage } from '@/data/localstorage';
import { Permission } from '@/entity/authentication/permission';
import { MenuItem } from '../../entity/menu-item';
import { BaseService } from '../base';

import { Capacitor } from "@capacitor/core";
import { QueryInfo } from '@/util';

export class AuthenticationService extends BaseService {
    signupInfoOf(credential: Credential, profile: Profile, email?: string, imei?: string) {
        const signupInfo: any = {
            mobile: credential.mobile,
            password: credential.password,
            firstName: profile.firstName,
            lastName: profile.lastName,
            gender: {
                code: profile.gender.code
            },
            DOB: moment(profile.dob).format("YYYY-MM-DD")
        }
        if(email) {
            signupInfo['email'] = email
        }        
        if(imei) {
            signupInfo['IMEI'] = imei
        }
        return signupInfo
    }

    //SCMT 2.0
    // 17-07-2024 newSignupInfoOf funtion start

    newSignupInfoOf(newCredential: NewCredential, newProfile: NewProfile, email?: string, imei?: string) {
        const signupInfo: any = {
            firstName : newProfile.firstName,
            mobile: newCredential.mobile
        }
        if(email) {
            signupInfo['email'] = email
        }  
        if(imei) {
            signupInfo['IMEI'] = imei
        }
        return signupInfo
    }
    // newSignupInfoOf funtion end

    async signupUserWithCredentialProfile(credential: Credential, profile: Profile, email?: string, imei?: string): Promise<User> {
        const signupInfo: any = this.signupInfoOf(credential, profile, email, imei)        
        const response = await axios.post(config.api.host + "/accounts/signup", {
            data: signupInfo
        });
        this.checkNetworkError(response);   
        //new LocalStorage().otp = response.data.meta;
        return Promise.resolve(new User(response.data.data.userId))
    }

    //SCMT 2.0
    // 17-07-2024 newSignupUserWithCredentialProfile, newsignupUserByOverritingExistingAccountWithCredentialProfile funtion start

    async newSignupUserWithCredentialProfile(newCredential: NewCredential, newprofile: NewProfile, email?: string, imei?: string): Promise<User> {
        const newSignupInfoOf : any = this.newSignupInfoOf(newCredential, newprofile, email, imei);
        // console.log(newSignupInfoOf)
        const response = await axios.post(config.api.host + "/accounts/signup", {
            data: newSignupInfoOf
        });
        this.checkNetworkError(response); 
        return Promise.resolve(new User(response.data.data.userId))
    }
    async newsignupUserByOverritingExistingAccountWithCredentialProfile(newCredential: NewCredential, newprofile: NewProfile, email?: string, imei?: string): Promise<User> {
        const signupInfo: any = this.newSignupInfoOf(newCredential, newprofile, email, imei)
        signupInfo['forcedCreate'] = 1
        const response = await axios.post(config.api.host + "/accounts/signup", {
            data: signupInfo
        });
        this.checkNetworkError(response);   
        //new LocalStorage().otp = response.data.meta;
        return Promise.resolve(new User(response.data.data.userId))
    }
    // newSignupUserWithCredentialProfile, newsignupUserByOverritingExistingAccountWithCredentialProfile funtion end

    async signupUserByOverritingExistingAccountWithCredentialProfile(credential: Credential, profile: Profile, email?: string, imei?: string): Promise<User> {
        const signupInfo: any = this.signupInfoOf(credential, profile, email, imei)
        signupInfo['forcedCreate'] = 1
        const response = await axios.post(config.api.host + "/accounts/signup", {
            data: signupInfo
        });
        this.checkNetworkError(response);   
        //new LocalStorage().otp = response.data.meta;
        return Promise.resolve(new User(response.data.data.userId))
    }

    //SCMT 2.0
    // 17.07.2024 newSigninUserWithCredential function start
    async newSigninUserWithCredential(newCredential: NewCredential): Promise<User> {
        const status = this.currentNetworkStatus();
        const data = {
            mobile: newCredential.mobile
        }
         
        const response = await axios.post(config.api.host + "/accounts/signinWithOtp"+ "?key=3966A518B00D3A543836E0906FC", {data});
        this.checkNetworkError(response);
        const user = new User(response.data.data.userId)
        // window.localStorage.setItem("user.id", user.id.toString())
        // window.localStorage.setItem("user.roleId", response.data.data.userRoleId)
        // window.localStorage.setItem("user.role", response.data.data.userRole)
        return Promise.resolve(user)
    }

    async verifyOtpForSignin(userId : number, otp: string): Promise<User> {
        let otpData = {
            data: {
                "userId" : userId,
                "OTP": otp
            }
        }
        const platform = Capacitor.getPlatform();
        
        let plt = "";
        if(platform == 'android') {
            plt = 'and';
        } else {
            plt = platform
        }
        const response = await axios.post(config.api.host + "/accounts/"+ userId + "/verifySigninOTP"+ "?key=3966A518B00D3A543836E0906FC", otpData, {
            headers: {
                "x-app-token": plt,
                "x-device-token": "1234567890"
            }
        })
        
        this.checkNetworkError(response);
        const user = new User(response.data.data.userId);
        window.localStorage.setItem("user.token", response.data.data.authToken)
        window.localStorage.setItem("user.id", user.id.toString())
        window.localStorage.setItem("user.roleId", response.data.data.userRoleId)
        window.localStorage.setItem("user.role", response.data.data.userRole)
        return Promise.resolve(user)
    }
    // newSigninUserWithCredential function end

    async signinUserWithCredential(credential: Credential): Promise<User> {
        const signinInfo = {
            data : {
                mobile: credential.mobile,
                password: credential.password
            }
        }
        
        // below code is depricated
        // const platform = (await Device.getInfo()).platform.replace("android", "and")
        const platform = Capacitor.getPlatform();
        let plt = "";
        if(platform == 'android') {
            plt = 'and';
        } else {
            plt = platform
        }
        const response = await axios.post(config.api.host + "/accounts/signin", signinInfo, {
            headers: {
                "Authorization": "Basic " + btoa(unescape(encodeURIComponent(credential.mobile + ":" + credential.password))),
                "x-app-token": plt,
                "x-device-token": "1234567890"
            }
        });

        this.checkNetworkError(response);
        const user = new User(response.data.data.userId)
        window.localStorage.setItem("user.token", response.data.data.authToken)
        window.localStorage.setItem("user.id", user.id.toString())
        window.localStorage.setItem("user.roleId", response.data.data.userRoleId)
        window.localStorage.setItem("user.role", response.data.data.userRole)
        return Promise.resolve(user)
    }

    async signOutUser(user: User): Promise<void> {
        await axios.post(config.api.host + "/accounts/" + user.id + "/signout", null, {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        new LocalStorage().clear()
        return Promise.resolve()
    }

    async permissionsOfUser(user: User): Promise<Permission[]> {
        const response = await axios.get(config.api.host + "/accounts/" + user.id + "/permissionsWithSubenu", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        const permissionsInfos: any[] = response.data.data.userPermissions
        const permissions: Permission[] = []
        permissionsInfos.forEach(permissionInfo => {
            permissions.push(new Permission(permissionInfo))
        });
        return Promise.resolve(permissions)
    }

    async menuAccessibilitiesOfUser(user: User): Promise<MenuItem[]> {
        const response = await axios.get(config.api.host + "/accounts/" + user.id + "/permissionsWithSubenu", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        const menuItemsInfos: any[] = response.data.data.menuItems
        // const menuItems: MenuItem[] = []
        // menuItemsInfos.forEach(menuItemInfo => {
        //     menuItems.push(new MenuItem("", menuItemInfo.description, "", new Permission(menuItemInfo.code, "")))
        // });
        // return Promise.resolve(menuItems)
        return Promise.resolve(menuItemsInfos)
    }

    async resendOtpForUser(user: User): Promise<void> {
        const response = await axios.post(config.api.host + "/accounts/" + user.id + "/resendotp", {
            data: {
                userId: user.id
            }
        })
        //new LocalStorage().otp = response.data.meta;
        return Promise.resolve()
    }

    async verifyOtpForUserWithMobileNo(otp: string, userData: User, mobile: string): Promise<User> {
        const userInfo = {
            data: {
                userId: userData.id,
                mobile: mobile,
                OTP: otp
            },
        }
        const platform = Capacitor.getPlatform();
        let plt = "";
        if(platform == 'android') {
            plt = 'and';
        } else {
            plt = platform
        }
        const response = await axios.post(config.api.host + "/accounts/" + userData.id + "/verifyotp"+ "?key=3966A518B00D3A543836E0906FC", userInfo,{
             headers: {
                "x-app-token": plt,
                "x-device-token": "1234567890"
            }
        })
        this.checkNetworkError(response);
        const user = new User(response.data.data.userId);
        window.localStorage.setItem("user.token", response.data.data.authToken)
        window.localStorage.setItem("user.id", user.id.toString())
        window.localStorage.setItem("user.roleId", response.data.data.userRoleId)
        window.localStorage.setItem("user.role", response.data.data.userRole)
        return Promise.resolve(user)
    }

    async recoverPasswordOfUserWithMobileNoByEmail(mobileNumber: string, email: string): Promise<User> {
        const response = await axios.post(config.api.host + "/accounts/generateOTP", {
            data: {
                mobile: mobileNumber,
                secretQuestionCode: {
                    code: "E"
                },
                secretAnswer: email
            }
        });
        this.checkNetworkError(response);
        //new LocalStorage().otp = response.data.meta;
        return Promise.resolve(new User(response.data.data.userId))   
    }

    async recoverPasswordOfUserWithMobileNoByDOB(mobileNumber: string, dob: Date): Promise<User> {        
        const response = await axios.post(config.api.host + "/accounts/generateOTP", {
            data: {
                mobile: mobileNumber,
                secretQuestionCode: {
                    code: "D"
                },
                secretAnswer: moment(dob).format("DD MMM YYYY")
            }
        });
        this.checkNetworkError(response);
        //new LocalStorage().otp = response.data.meta;
        return Promise.resolve(new User(response.data.data.userId))  
    }

    async resetPasswordForUserWithOTP(password: string, user: User, otp: string): Promise<void> {
        await axios.post(config.api.host + "/accounts/" + user.id + "/resetpassword", {
            data: {
                userId: user.id,
                OTP: otp,                
                password: password
            }
        });
        return Promise.resolve()
    }

    async secretQuestions(): Promise<SecretQuestion[]> {
        const response = await axios.get(config.api.host + "/accounts/secretquestions");
        this.checkNetworkError(response);
        let secretQuestionsInfos: any[] = response.data.data
        if(!(secretQuestionsInfos instanceof Array)) {
            secretQuestionsInfos = JSON.parse(secretQuestionsInfos)
        }        
        const secretQuestions: SecretQuestion[] = []
        secretQuestionsInfos.forEach(secretQuestionInfo => {
            secretQuestions.push(new SecretQuestion(secretQuestionInfo.code, secretQuestionInfo.description))
        });
        return Promise.resolve(secretQuestions)
    }
    
    // Corporate forgot password
    
    async recoverPasswordOfUserWithoutMobileNoAndEmail(mobileNumber: string, email: string): Promise<User> {
        const response = await axios.post(config.api.host + "/corporate/corpGenerateOTP", {
            data: {
                mobile: mobileNumber,
                secretQuestionCode: {
                    code: ""
                },
                secretAnswer: ""
            }
        });
        this.checkNetworkError(response);
        //new LocalStorage().otp = response.data.meta;
        return Promise.resolve(new User(response.data.data.userId))   
    }
    async resetPasswordForAdminUserWithoutOTP(password: string, user: User): Promise<void> {
        await axios.post(config.api.host + "/accounts/" + user.id + "/resetpasswordForAdmin", {
            data: {
                userId: user.id,         
                password: password
            }
        });
        return Promise.resolve()
    }
    async getAppVersion() {
        let userId = localStorage.getItem("user.id")
        const platform = Capacitor.getPlatform();
        const response = await axios.get(config.api.host + "/v1/" + userId +"/appVersionBasedOnPlatform/" + platform, {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        const appVersion  = response.data.data[0]
        return Promise.resolve(appVersion)
    }
    
    async getApkVersion() {
        let userId = localStorage.getItem("user.id")
        const platform = Capacitor.getPlatform();
        const response = await axios.get(config.api.host + "/v1/" + userId +"/currentAppVersion/" + platform, {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        const appVersion  = response.data.data[0]
        return Promise.resolve(appVersion)
    }
    async getUserProfileAndVehicleDetails() {
        let userId = localStorage.getItem("user.id")
        let roleId = localStorage.getItem("user.roleId")
        const response = await axios.get(config.api.host + "/v1/" + userId +"/displayOnboardMessage/" + roleId, {
            headers: {
                Authorization : new LocalStorage().authToken
            },
        })
        return Promise.resolve(response.data.data)
    }
    async getForceUpdateFlag() {
        let userId = localStorage.getItem("user.id")
        const platform = Capacitor.getPlatform();
        const response = await axios.get(config.api.host + "/v1/" + userId +"/getForceUpdateFlag/" + platform, {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        const forceUpdateFlag  = response.data.data.forceUpdateFlag[0]
        return Promise.resolve(forceUpdateFlag)
    }
}